export enum SMS_STATUS {
    FAILED = "failed",
    QUEUED = "queued",
    DELIVERED = "delivered",
    UNDERIVED = "undelivered",
    SENT = "sent",
    RECEIVED = "received"
}

export const SMS_STATUS_OPTIONS = [
    {id: SMS_STATUS.FAILED, name: "Failed"},
    {id: SMS_STATUS.QUEUED, name: "Queued"},
    {id: SMS_STATUS.DELIVERED, name: "Delivered"},
    {id: SMS_STATUS.UNDERIVED, name: "Undelivered"},
    {id: SMS_STATUS.SENT, name: "Sent"},
    {id: SMS_STATUS.RECEIVED, name: "Received"}
]
